<app-login-layout>
  <div class="mainContent">
    <div>
      <h2>{{ trans('auth.labels.createPassword') }}</h2>
      <p>{{ trans('auth.labels.createPasswordPrompt') }}</p>
    </div>
    <form (submit)="next()">
      <input type="hidden" [value]="login.email" [disabled]="isLoading"/>
      <app-string-input
        [label]="trans('auth.form.newPassword')"
        type="password"
        name="password"
        autocomplete="new-password"
        [(value)]="login.password"
        [hasError]="val.hasError('email')"
        [disabled]="isLoading"
      >
        <app-form-error *ngIf="val.hasError('password')">{{ val.getError('password') }}</app-form-error>
      </app-string-input>
      <app-button type="filled-secondary" class="mainButton" [isLoading]="isLoading">{{ trans('general.next') }}</app-button>
    </form>
  </div>
</app-login-layout>
